// 1_utils/scroll_to_element.js
// Exposed on window.NAT.utils so any .js file (2_components, 3_pages, …) can call
// it without an import:  window.NAT.utils.scrollToElement(myEl);

window.NAT = window.NAT || {};
window.NAT.utils = window.NAT.utils || {};

window.NAT.utils.scrollToElement = function (element) {
	if (!element) return;
	// Offset by the fixed header height if a #header exists (don't throw if not).
	const header = document.querySelector("#header");
	const headerHeight = header ? header.offsetHeight : 0;
	window.scrollTo({
		top: element.getBoundingClientRect().top + window.pageYOffset - headerHeight,
		behavior: "smooth",
	});
};
